import { clsx } from 'clsx';
import { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { ILinkProps, Link } from 'atoms/Link/Link';
import { Span } from 'atoms/Typography';
import styles from './styles.module.css';

export const LinkWithIcon: FC<
  ILinkProps & {
    text: string;
    icon?: IconType;
    iconClassName?: string;
    textClassName?: string;
  }
> = ({
  text = '',
  icon = IconType.arrowRight,
  iconClassName,
  textClassName,
  ...LinkProps
}) => {
  return (
    <Link {...LinkProps} className={clsx(styles.link, LinkProps.className)}>
      <Icon type={icon} className={clsx(styles.icon, iconClassName)} />
      <Span className={textClassName}>{text}</Span>
    </Link>
  );
};
